/**
 * 模块说明：订单参数管理
 */
import { Service } from '@/tools'
export class OrderParameterSettingsServer<T extends TOrder.OrderParameterSettings> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.OrderParameterSettings}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：获取订单参数设置
   * /api/order/orderParameterSettings/v1/getOrderParameterSettings
   */
  getOrderParameterSettings = <K extends T['ApiGetOrderParameterSettings']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetOrderParameterSettings', data)
  /**
   * 功能：更新订单参数设置
   * /api/order/orderParameterSettings/v1/updateGlobalSetting
   */
  updateGlobalSetting = <K extends T['ApiUpdateGlobalSetting']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateGlobalSetting', data)

  /**
   * 功能：分页查询部分放单规则
   */
  partialRulePage = (data: T['ApiPartialRulePage']['req']): Promise<T['ApiPartialRulePage']['res']> => this.post2('v1/ApiPartialRulePage', data)

  /**
   * 功能：删除订单参数设置
   */
  deleteSettingDetail = (data: T['ApiDeleteSettingDetail']['req']): Promise<T['ApiDeleteSettingDetail']['res']> =>
    this.post2('v1/ApiDeleteSettingDetail', data)

  /**
   * 功能：参数设置
   * /api/order/orderParameterSettings/v1/querySettingByGroup
   */

  querySettingByGroup = (data: T['ApiQuerySettingByGroup']['req']): Promise<T['ApiQuerySettingByGroup']['res']> =>
    this.post2('v1/ApiQuerySettingByGroup', data)
}
